/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserGroupAssignmentUser } from './UserGroupAssignmentUser';
import {
    UserGroupAssignmentUserFromJSON,
    UserGroupAssignmentUserFromJSONTyped,
    UserGroupAssignmentUserToJSON,
    UserGroupAssignmentUserToJSONTyped,
} from './UserGroupAssignmentUser';

/**
 * 
 * @export
 * @interface UserGroupAssignment
 */
export interface UserGroupAssignment {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    user_group_id: string;
    /**
     * 
     */
    user?: UserGroupAssignmentUser;
}

/**
 * Check if a given object implements the UserGroupAssignment interface.
 */
export function instanceOfUserGroupAssignment(value: object): value is UserGroupAssignment {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('user_group_id' in value) || value['user_group_id'] === undefined) return false;
    return true;
}

export function UserGroupAssignmentFromJSON(json: any): UserGroupAssignment {
    return UserGroupAssignmentFromJSONTyped(json, false);
}

export function UserGroupAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'user_id': json['user_id'],
        'user_group_id': json['user_group_id'],
        'user': json['user'] == null ? undefined : UserGroupAssignmentUserFromJSON(json['user']),
    };
}

export function UserGroupAssignmentToJSON(json: any): UserGroupAssignment {
    return UserGroupAssignmentToJSONTyped(json, false);
}

export function UserGroupAssignmentToJSONTyped(value?: UserGroupAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['user_id'],
        'user_group_id': value['user_group_id'],
        'user': UserGroupAssignmentUserToJSON(value['user']),
    };
}

